"use strict";
document.addEventListener("DOMContentLoaded", function () {

     // === LAZY LOADING SETUP ===
    // Inițializare Vanilla LazyLoad
    if (typeof LazyLoad !== 'undefined') {
        new LazyLoad({
            //elements_selector: ".lazyload",
            use_native: true,
            threshold: 300,
            callback_loaded: (el) => {
                // Opțional: adaugă o clasă după ce imaginea e încărcată
                el.classList.add("image-loaded");
            }
        });
    }

// Company slider
      let heroServiceSlider = document.querySelector('.hero-service-carousel');
    if(heroServiceSlider){
      const swiper = new Swiper(heroServiceSlider, {
        loop: true,
        speed:12000,
        autoplay: {
          delay:1,
        },
        spaceBetween: 24,

        slidesPerView: 1,
   
        clickable: true,
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          300: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
          350: {
            slidesPerView: 1.3,
            spaceBetween: 10,
          },
          450: {
            slidesPerView:1.5,
            spaceBetween: 10,
          },
          700: {
            slidesPerView:2,
            spaceBetween: 10,
          },
          1100: {
            slidesPerView: 3,
            spaceBetween: 24,
            centeredSlides: true,
          },
        }
      });
    }

     // expert-slider-carousel
     let expertSliderImg = document.querySelectorAll('.expert-slider-carousel');
     expertSliderImg && expertSliderImg.forEach(function(expertSliderImg) {
       var swiper = new Swiper(expertSliderImg, {
        loop: true,
        slidesPerView: 1, 
        slidesToShow: 1,
        paginationClickable: true,
        spaceBetween: 12,
         navigation: {
           nextEl: expertSliderImg.querySelector('.ara-next'),
           prevEl: expertSliderImg.querySelector('.ara-prev'),
         },
         
       });
     });

          // expert-slider-carousel
          let expertSlider2 = document.querySelectorAll('.expert2-slider-carousel');
          expertSlider2 && expertSlider2.forEach(function(expertSlider2) {
            var swiper = new Swiper(expertSlider2, {
             loop: true,
             slidesPerView: 1,
             centeredSlides: false,
             spaceBetween: 24,
             navigation: true,
             scrollbar: {
              el: ".swiper-scrollbar",
            },
            breakpoints: {
  
              600: {
                slidesPerView:1,
                spaceBetween: 10,
              },
              950: {
                slidesPerView: 2,
                spaceBetween: 24,
                centeredSlides: true,
              },
              1300: {
                slidesPerView: 3,
                spaceBetween: 24,
        
              },
            }
            });
          });


          // expert-slider-carousel
          let homeFourHeroSlider = document.querySelectorAll('.home-four-slider-carousel');
          homeFourHeroSlider && homeFourHeroSlider.forEach(function(homeFourHeroSlider) {
            var swiper = new Swiper(homeFourHeroSlider, {
              direction: "vertical",
             loop: true,
             slidesPerView: 4,
             speed:10000,
             autoplay: {
               delay:1,
             },

             breakpoints: {
              0: {
                slidesPerView:13,
                spaceBetween: 10,
              },
              350: {
                slidesPerView:11,
                spaceBetween: 10,
              },

              400: {
                slidesPerView:9,
                spaceBetween: 10,
              },
              500: {
                slidesPerView:8,
                spaceBetween: 10,
              },
              620: {
                slidesPerView:7,
                spaceBetween: 10,
              },
  
              880: {
                slidesPerView:6,
                spaceBetween: 10,
              },
              1150: {
                slidesPerView: 5,
                spaceBetween: 24,
                centeredSlides: true,
              },
              1500: {
                slidesPerView: 4,
                spaceBetween: 24,
        
              },
            }
            });
          });

          // Home theree testimonial slider
      let homeThreeTestimonial = document.querySelector('.home3-testimonial-carousel');
      if(homeThreeTestimonial){
        const swiper = new Swiper(homeThreeTestimonial, {
          loop: true,
          autoplay: {
            delay:3000,
          },
          spaceBetween: 24,
          slidesPerView: 1,
          clickable: true,
          navigation: {
            nextEl: homeThreeTestimonial.querySelector('.ara-next'),
            prevEl: homeThreeTestimonial.querySelector('.ara-prev'),
          },
          pagination: {
            el: ".swiper-pagination",
            clickable:true,
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
              spaceBetween: 24,
            },
            768: {
              slidesPerView:2,
              spaceBetween: 24,
            },
            992: {
              slidesPerView:2,
              spaceBetween: 100,
            },
          }
        });
      }

      // reviews sidebarslider
        let reviewSlider = document.querySelector('.review-swiper');

        if (reviewSlider) {
          let swiper = new Swiper(reviewSlider, {
            loop: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
            },
            slidesPerView: 1,
            spaceBetween: 20,
            navigation: false,
          });

          // Go through each review and check height
          reviewSlider.querySelectorAll('.swiper-slide').forEach(slide => {
            let text = slide.querySelector('.review-text');
            let button = slide.querySelector('.toggle-review-btn');

            if (text && button) {
              // Check if text is overflowing
              if (text.scrollHeight <= text.clientHeight + 5) {
                button.style.display = 'none';
              } else {
                button.style.display = 'inline-block';
                button.addEventListener('click', function () {
                  text.classList.toggle('expanded');
                  this.textContent = text.classList.contains('expanded') ? 'Show less' : 'Read more';
                });
              }
            }
          });
        }





        // home four testimonial-carousel
      let testimonial4 = document.querySelectorAll('.testimonial4-slider-carousel');
      testimonial4 && testimonial4.forEach(function(testimonial4) {
        var swiper = new Swiper(testimonial4, {
          loop: true,
          slidesPerView: 1,
          slidesToShow: 1,
          paginationClickable: true,
          spaceBetween: 12,
          navigation: {
            nextEl: testimonial4.querySelector('.ara-next'),
            prevEl: testimonial4.querySelector('.ara-prev'),
          },
          
        });
      });




     // expert-slider-carousel
     let loginSlider1 = document.querySelectorAll('.login-slider1-carousel');
     loginSlider1 && loginSlider1.forEach(function(loginSlider1) {
       var swiper = new Swiper(loginSlider1, {
         direction: "vertical",
        loop: true,
        slidesPerView: 1,
        speed:5000,
        autoplay: {
          delay:0,
          reverseDirection:true,
        },

        breakpoints: {
         0: {
           slidesPerView:1,
           spaceBetween: 5,
         },
         
         700: {
           slidesPerView: 2.2,
   
         },
       }
       });
     });

          // expert-slider-carousel
          let loginSlider2 = document.querySelectorAll('.login-slider2-carousel');
          loginSlider2 && loginSlider2.forEach(function(loginSlider2) {
            var swiper = new Swiper(loginSlider2, {
              direction: "vertical",
              reverse:"true",
             loop: true,
             slidesPerView: 1,
             speed:5000,
             autoplay: {
               delay:0,
             },
             breakpoints: {
              0: {
                slidesPerView:1,
              },
              700: {
                slidesPerView: 2.2,
              },
            }
            });
          });



           //initialize aos
AOS.init()


  // Funcția principală pentru a configura formularele
  function setupCustomForms() {
    const forms = document.querySelectorAll('.wpcf7-form');
    
    forms.forEach(form => {
      // Verifică dacă forma are deja un buton personalizat
      if (form.querySelector('.custom-submit-button')) {
        return; // Skip dacă butonul există deja
      }
      
      // Caută butonul de submit original
      const originalSubmit = form.querySelector('input[type="submit"]');
      
      if (originalSubmit) {
        console.log('Buton original găsit:', originalSubmit);
        
        // Creează butonul custom
        const customButton = document.createElement('button');
        customButton.type = 'button';
        customButton.className = 'custom-submit-button relative flex items-center justify-center overflow-hidden rounded-xl bg-b300 px-4 py-3 font-semibold text-white duration-700 hover:text-n900 sm:px-8';
        customButton.innerHTML = '<span class="relative z-10">Submit</span><span class="absolute inset-0 left-0 w-0 rounded-xl bg-yellow-400 duration-700 z-0"></span>';
        
        // Înlocuiește butonul original cu cel custom
        const submitContainer = originalSubmit.parentNode;
        originalSubmit.style.display = 'none';
        submitContainer.appendChild(customButton);
        
        // Adaugă funcționalitate butonului custom
        customButton.addEventListener('click', function() {
          // Simulează click pe butonul original
          originalSubmit.click();
        });
        
        // Hover effect
        customButton.addEventListener('mouseenter', function() {
          const bgSpan = customButton.querySelector('span:last-child');
          bgSpan.style.width = 'calc(100% + 2px)';
          customButton.classList.add('text-n900');
        });
        
        customButton.addEventListener('mouseleave', function() {
          const bgSpan = customButton.querySelector('span:last-child');
          bgSpan.style.width = '0';
          customButton.classList.remove('text-n900');
        });
      } else {
         //console.log('Butonul original nu a fost găsit în formularul:', form);
      }
      
      // Event listeners pentru răspunsuri
      form.addEventListener('wpcf7mailsent', handleSuccess);
      form.addEventListener('wpcf7invalid', handleError);
      form.addEventListener('wpcf7mailfailed', handleError);
    });
  }
  
  function handleSuccess(event) {
    const form = event.target;
    const responseMsg = form.querySelector('.response-message');
    if (responseMsg) {
      responseMsg.textContent = 'Thanks for your message!';
      responseMsg.classList.add('success');
      responseMsg.classList.remove('hidden');

      // Redirect după submit cu succes
      const redirectUrl = 'https://dublin-carpetcleaning.ie/thank-you/'; 
      setTimeout(() => {
      window.location.href = redirectUrl;
      }, 500); // ajustează delay-ul dacă vrei (ex: 0, 500, 1500)
      
      // Reset form după 3 secunde
      setTimeout(() => {
        form.reset();
        responseMsg.classList.add('hidden');
        responseMsg.classList.remove('success');
      }, 3000);
    }
  }
  
  function handleError(event) {
    const form = event.target;
    const responseMsg = form.querySelector('.response-message');
    if (responseMsg) {
      responseMsg.textContent = event.type === 'wpcf7invalid' ? 
        'Please fill in all fields correctly.' : 
        'There was an error sending the message. Please try again.';
      responseMsg.classList.add('error');
      responseMsg.classList.remove('hidden');
    }
  }

  // Utilizăm MutationObserver pentru a detecta când formularul apare în DOM
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          const node = mutation.addedNodes[i];
          if (node.nodeType === 1 && node.matches('.wpcf7-form') || 
              (node.nodeType === 1 && node.querySelector('.wpcf7-form'))) {
            console.log('Formular CF7 detectat în DOM');
            setupCustomForms();
          }
        }
      }
    });
  });

  // Configurăm și pornim observatorul pentru întregul document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Verificăm și dacă formularul este deja în DOM
  // console.log('Verificare inițială pentru formulare CF7...');
  setupCustomForms();
  
  // Re-setup după ce AJAX CF7 se termină
  document.addEventListener('wpcf7submit', function() {
    console.log('Eveniment wpcf7submit declanșat');
    setTimeout(setupCustomForms, 500);
  });


});